const envValue = (value: string | undefined, defaultValue: boolean) => {
  if (value === undefined) return defaultValue;
  return value.toLowerCase() === 'true';
};

// When true, permission checks rely on user.permissions from API/local storage.
// When false, app can fall back to hardcoded role permission maps.
export const RBAC_USE_DB_PERMISSIONS = envValue(import.meta.env.VITE_RBAC_USE_DB_PERMISSIONS, false);

// When true, AuthContext will NOT derive permissions from role maps.
// This is the transition kill-switch to disable mock/hardcoded role assignment.
export const RBAC_DISABLE_MOCK_ROLE_ASSIGNMENT = envValue(
  import.meta.env.VITE_RBAC_DISABLE_MOCK_ROLE_ASSIGNMENT,
  false,
);
